// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__1Oc0r","inactive":"Section_inactive__2V-gx"};